import { useState } from 'react'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { InputWrapper } from '../../../components/input/input.style'
import { Input } from '../../../components/input'
import { Textarea } from '../../../components/textarea'
import {
    Container,
    MainContentWrapper,
    Heading,
    PageWrapper,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { FilterBtn } from '../../../styles/results'
import { CalendarComponent } from '../../../components/calendar'
import { CalendarGrid } from '../../../styles/calendar'
import TasksChart from "../../../components/dashboard-overview/overview-tasks-pending-card/chart"
import { CustomModal } from '../../../components/modal'
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import DatePicker from '@material-ui/lab/DatePicker';
import { Button } from '../../../components/button';
import { TextField } from '@material-ui/core';

const schema = yup.object().shape({
    eventName: yup.string().required("First name is a required field"),
    description: yup.string().required("Last name is a required field "),
    date: yup.date().required("Date is a required field"),

});

const TeacherCalendar = () => {
    const [showModal, setShowModal] = useState(false);
    const [dateValue, setDateValue] = useState(null);
    const {
        handleSubmit,
        register,
        formState: { errors },
        watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });
    // const formData = JSON.stringify(watch());

    const onSubmit = values => {
        console.log(values)
    }
    return (
        <>
            <CustomModal title="Add a New Task/Event" onClose={() => setShowModal(false)} showModal={showModal} >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InputWrapper>
                        <Input
                            type="text"
                            fullWidth
                            placeholder="Task event name"
                            {...register("eventName")}
                            error={errors.eventName?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            type="text"
                            fullWidth
                            placeholder="Description"
                            {...register("description")}
                            error={errors.description?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                value={dateValue}
                                onChange={(newValue) => {

                                    setDateValue(newValue);
                                    console.log(dateValue)
                                }}
                                renderInput={({ inputRef, inputProps, InputProps }) => (
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <Input {...register("date")} error={errors.date?.message} fullWidth ref={inputRef} {...inputProps} />
                                        {InputProps?.endAdornment}
                                    </div>
                                )}
                            />
                        </LocalizationProvider>
                    </InputWrapper>
                    <Button type="submit">
                        create task
                    </Button>
                </form>
            </CustomModal>


            <DashboardWrapper>
                <MainContentWrapper fullHeight>
                    <Container>
                        <PageWrapper>
                            <FilterBtn onClick={() => setShowModal(true)}>
                                CREATE TASK
                            </FilterBtn>
                            <Heading>
                                Calendar
                            </Heading>
                            <Breadcrumb
                                crumbs={['Calendar']}
                            />
                            <CalendarGrid>

                                <CalendarComponent />
                                <div style={{
                                    backgroundColor: "#fff"
                                }}>
                                    <TasksChart />
                                </div>
                            </CalendarGrid>
                        </PageWrapper>
                    </Container>
                </MainContentWrapper>
            </DashboardWrapper>
        </>
    )
}

export default TeacherCalendar
